import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import MainRoutes from './router'
import './style/styles.scss'

const App = () => {
  return (
    <React.StrictMode>
        <BrowserRouter>
          <MainRoutes />
        </BrowserRouter>
    </React.StrictMode>
  )
}

export default App